// would be called from the component to dispatch the action
export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const VERIFY_CODE = "VERIFY_CODE";
export const CREATE_USER = "CREATE_USER";

// interal action names which would be used by the saga effects to update the data
const ACTION_LOADER = "ACTION_LOADER";
const SET_AUTH_DATA = "SET_AUTH_DATA";
const SET_REQUEST_LOGIN = "SET_REQUEST_LOGIN"
const SET_USER_DATE = "SET_USER_DATE";
const SET_ERROR = "SET_ERROR";
const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
const SET_ERROR_CODE = "SET_ERROR_CODE"

export const requestLogin = (payload) => ({
  type: REQUEST_LOGIN,
  payload,
});

export const verifyCode = (payload) => ({
  type: VERIFY_CODE,
  payload,
})

export const createUser = (payload) => ({
  type: CREATE_USER,
  payload,
})

export const setRequestLogin = (payload) => ({
  type: SET_REQUEST_LOGIN,
  payload,
})
export const setAuthData = (payload) => ({
  type: SET_AUTH_DATA,
  payload,
});

export const setUserData = (payload) => ({
  type: SET_USER_DATE,
  payload,
});

export const setError = (payload) => ({
  type: SET_ERROR,
  payload,
})

export const setLoaderState = (loadingState) => ({
  type: ACTION_LOADER,
  loadingState,
});

export const setErrorMessage = (payload) => ({
  type: SET_ERROR_MESSAGE,
  payload
})

export const setErrorCode = (payload) => ({
  type: SET_ERROR_CODE,
  payload
})

const initialState = {
  isAuthenticated: false,
  user: {},
  isRequestLoginSuccessfull: false,
  isUserCreated: false,
  isVerifyCodeError: false,
  errorCode: "",
  isLoading: false,
  errorMessage: "",
  isError: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_DATA: // on submit of otp
      return { ...state, isAuthenticated: action.payload };
    case SET_REQUEST_LOGIN: // requesting on the email from the sign in flow
      return { ...state, isRequestLoginSuccessfull: action.payload,};
    case ACTION_LOADER:
      return { ...state, isLoading: action.loadingState };
    case SET_USER_DATE: // once the user api is called
      return { ...state, isUserCreated: action.payload}
    case SET_ERROR:
      return {...state, isError: action.payload}
    case SET_ERROR_MESSAGE:
      return {...state, errorMessage: action.payload}
    case SET_ERROR_CODE:
      return {...state, errorCode: action.payload}
    default:
      return state;
  }
};
